import * as React from 'react';
import {
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogContent,
    Button,
    makeStyles,
} from '@fluentui/react-components';
import Results from './Results';
import { ChatScriptResponse } from '../../Service/ServerAPI';

interface ResultsDialogWrapperProps {
    result: ChatScriptResponse | null;
    isScriptRunning: boolean;
    showDialog: boolean;
    onClose: () => void;
}

const useStyles = makeStyles({
    dialogContent: {
        padding: '20px',
    },
    dialogFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px',
    },
});

const ResultsDialogWrapper: React.FC<ResultsDialogWrapperProps> = ({
    result,
    isScriptRunning,
    showDialog,
    onClose,
}) => {
    const classes = useStyles();

    return (
        <Dialog open={showDialog} onOpenChange={() => onClose()}>
            <DialogSurface>
                <DialogTitle>Results</DialogTitle>
                <DialogBody>
                    <DialogContent className={classes.dialogContent}>
                        <Results
                            result={result}
                            isScriptRunning={isScriptRunning}
                        />
                    </DialogContent>
                    <div className={classes.dialogFooter}>
                        <Button onClick={onClose}>Close</Button>
                    </div>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default ResultsDialogWrapper;
